import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_TRANSPORT_NETWORK_INLCM_9 = {
  title:
    "Along with the device creation, view \ninter-chassis links created by default \nfor duplex devices.",
  subtitle: "Transport Network",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_333"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_323"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_transport_net_09_screen.png",
          imageStyle: { position: "absolute", bottom: "328px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_transport_net_09_popup.png",
          imageStyle: { position: "absolute", bottom: "185px", right: "282px" },
        },
      ]}
      pageNumber={"ENG_330"}
    />
  ),
};
